import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="none"
        stroke="#131313"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M430.484 180.949h-19.437v-34.931c0-1.383-1.199-2.494-2.668-2.494h-40.672c-1.46 0-2.649 1.111-2.649 2.494v34.931H144.501v-34.931c0-1.383-1.189-2.494-2.658-2.494H101.18c-1.479 0-2.648 1.111-2.648 2.494v34.931H82.178c-9.482 0-17.175 7.674-17.175 17.185v240.661c0 9.502 7.693 17.205 17.175 17.205h348.306c9.482 0 17.176-7.703 17.176-17.205V198.134c0-9.511-7.694-17.185-17.176-17.185z"
      />
      <path
        fill="none"
        stroke="#131313"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M143.111 390.833a10 10 0 0 1-6.539-17.572l124.522-107.433a9.996 9.996 0 0 1 10.684-1.526 9.998 9.998 0 0 1 5.848 9.072l.052 20.998 87.729-44.869a10 10 0 0 1 11.086 16.474L251.981 373.403a9.996 9.996 0 0 1-10.683 1.527 10 10 0 0 1-5.849-9.068l-.061-21.004-87.729 44.877a9.965 9.965 0 0 1-4.548 1.098zM366.97 80.788h48.867M98.223 80.788h48.866M122.656 56.355v48.867"
      />
    </svg>
  );
};

export default Icon;
